import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import { withFeedback } from '@app/core/interceptors/feedback-context'
import { ApiService } from '@shared/services/api.service'
import { EventLogSetting } from './shared/event-log-setting.model'
import { EventLog } from './shared/event-log.model'
import { NotificationAcknowledgeHistory, NotificationAcknowledgeHistoryPayload } from '@shared/models/notification-acknowledge.model'
import { ExportFileTypes } from '@shared/models/export-file-types.enum'
import { FilterValues } from '@shared/models/filter-values.model'
@Injectable()
export class AlertsService {
  constructor(private apiService: ApiService) {}

  getList(
    pageIndex = 0,
    pageSize = 10,
    sort?: string,
    filterValues?: { [param: string]: string | number | (string | number)[] },
    fields?: (keyof EventLog)[],
  ) {
    return this.apiService.getPageable<EventLog>('/event-log/json', pageIndex, pageSize, sort, filterValues, fields)
  }

  exportFile(columns: string[], sort: string, filterValues: FilterValues, type: ExportFileTypes): Observable<string> {
    return this.apiService.exportFile(`/event-log/${type}`, columns, sort, filterValues)
  }

  getEventAcknowledgeHistory(id: number): Observable<NotificationAcknowledgeHistory[]> {
    return this.apiService.get(`/notifications/acknowledge/${id}/history`).pipe(map((resp) => resp['data'].reverse()))
  }

  updateEventAcknowledgeHistory(
    id: number,
    historyPayload: NotificationAcknowledgeHistoryPayload,
  ): Observable<NotificationAcknowledgeHistory[]> {
    return this.apiService
      .post(`/notifications/acknowledge/${id}`, historyPayload, { context: withFeedback() })
      .pipe(map((resp) => resp['data']))
  }

  getEventLogSettings(): Observable<EventLogSetting[]> {
    return this.apiService.get('/notifications/alert/setting').pipe(map((resp) => resp['data']))
  }
}
